import { render, staticRenderFns } from "./FounderIntro.vue?vue&type=template&id=6ed9e5ce&scoped=true&"
import script from "./FounderIntro.vue?vue&type=script&lang=js&"
export * from "./FounderIntro.vue?vue&type=script&lang=js&"
import style0 from "./FounderIntro.vue?vue&type=style&index=0&id=6ed9e5ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9e5ce",
  null
  
)

export default component.exports